<style>
  body, div, span, input, form, button {
    margin: 0;
    padding: 0;
  }

  html, body {
    height: 100%;
  }

  #body {
    height: 100%;
    min-height: 568px;
    font-family: 'Microsoft Yahei';
    min-width: 1200px;
    /*  background: url("./assets/imgs/user/login/login_bg.png") no-repeat;*/
    background-size: 100% 100%;
    background-color: #324157;
  }

  /**start改变组件，使其自适应*/
  .login-origion .el-alert {
    padding: 0.5rem 0 0.5rem 1rem !important;
    text-align: left;
    width: 18.75rem !important;
    margin: 0.1875rem auto 0 auto;
  }

  .login-origion .el-alert__icon {
    font-size: 1rem;
    width: 1rem;
    display: table-cell;
    color: #fff;
    vertical-align: middle;
  }

  .login-origion .el-alert__content {
    display: table-cell;
    padding: 0 0.5rem;
  }

  .login-origion .el-alert__title {
    font-size: 0.8125rem;
    line-height: 1.125rem;
  }

  /**end*/
  .platformBox { /**/
    margin: 15px 0 35px;
    border-bottom: 2px solid #f3f3f3;
    text-align: center;
    color: #f59a3d;
    font-size: 19px;
    padding: 10px;
    line-height: 50px;
    height: 50px;
  }

  .login-origion { /**/
    width: 100%;
    height: 100%;
    float: right;
    position: relative;
  }

  .login-box { /**/
    width: 25rem;
    height: 23.75rem;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -11.875rem;
    margin-left: -12.5rem;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    text-align: center;
  }

  .username-line, .password-line, .remember-password {
    width: 18.75rem;
    height: 2.25rem;
    line-height: 2.25rem;
    margin: 0 auto;
  }

  .remenber-line {
    width: 18.75rem;
    margin: 0 auto
  }

  .verification-line {
    width: 300px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto;
  }

  .username-line {
    margin-top: 15px;
  }

  .password-line {
    margin-top: 20px;
  }

  .username-line i {
    width: 32px;
    height: 32px;
    display: inline-block;
    float: left;
    background: url("./assets/imgs/user/login/user_icon.png") no-repeat center;
  }

  .password-line i {
    width: 32px;
    height: 32px;
    display: inline-block;
    float: left;
    background: url("./assets/imgs/user/login/password_icon.png") no-repeat center;
  }

  /*    .check-box{
          float:right;
          margin-right:10px;
          font-size: 12px;
          color:#333;
          position: relative;
      }
      .check-box input{
          display:inline-block;
          width:14px;
          height:14px;
          padding-top: 2px;
          position: absolute;
          right:50px;
          top:50%;
          margin-top:-7px;
      }*/
  .login-btn {
    width: 19.18rem;
    height: 3.0rem;
    line-height: 3.0rem;
    border: none;
    background-color: #fc774c;
    color: #fff;
    border-radius: 1.56rem;
    font-size: 0.875rem;
    font-family: "Microsoft Yahei";
    margin: 1.25rem auto 0;
    outline: none;
    background: url("./assets/imgs/user/login/btn.png") no-repeat center;
  }

  .login-btn:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }

  /*移动端登录界面*/
  @media screen and (max-width: 768px) {
    #body {
      background: url("./assets/imgs/user/login/mobile_bg.png") no-repeat;
      background-size: 100% 100%;
      min-width: 320px;
    }

    .platformBox {
      font-size: 1.3rem;
      margin: 0.9375rem auto 2.1875rem;
      border-bottom: 1px solid #f3f3f3;
      text-align: center;
      color: #ededed;
      padding: 0.624rem 0px 0.125rem;
      line-height: 3.125rem;
      height: 3.125rem;
      width: 19rem;
    }

    .login-origion {
      width: 100%;
      position: relative;
      float: none;
    }

    .login-box {
      background-color: transparent;
    }

    #userID .el-input__inner, #password .el-input__inner {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      outline: none;
      color: rgba(255, 255, 255, 0.7);
      border-radius: 0;
    }

    #userID input::-webkit-input-placeholder, #password input::-webkit-input-placeholder, .verification-line input::-webkit-input-placeholder { /* WebKit browsers */
      color: rgba(255, 255, 255, 0.4);
    }

    #userID input:-moz-placeholder, #password input:-moz-placeholder, .verification-line input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: rgba(255, 255, 255, 0.4);
    }

    #userID input::-moz-placeholder, #password input::-moz-placeholder, .verification-line input::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: rgba(255, 255, 255, 0.4);
    }

    #userID input:-ms-input-placeholder, #password input:-ms-input-placeholder, .verification-line input:-ms-input-placeholder { /* Internet Explorer 10+ */
      color: rgba(255, 255, 255, 0.4);
    }

    .remenber-line {
      color: #ffffff;
    }

    .username-line i {
      width: 31px;
      height: 31px;
      background: url("./assets/imgs/user/login/user_mobile.png") no-repeat center;
    }

    .password-line i {
      width: 31px;
      height: 31px;
      background: url("./assets/imgs/user/login/password_mobile.png") no-repeat center;
    }

    .username-line .el-input-group__prepend, .password-line .el-input-group__prepend {
      box-sizing: border-box;
      background-color: transparent;
      border: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      border-radius: 0;
    }

    .login-btn {
      width: 19.1875rem;
      height: 3.125rem;
      line-height: 3.125rem;
      border: none;
      background: url("./assets/imgs/user/login/btn_mobile.png") no-repeat center;
      color: #fff;
      border-radius: 1.5625rem;
      font-size: 1.125rem;
      font-family: "Microsoft Yahei";
      margin: 1.875rem auto 0;
      outline: none;
    }

    .mobile-header span {
      display: block;
      width: 100%;
      height: 98px;;
      margin-bottom: 20px;
      background: url("./assets/imgs/user/login/logo_mobile.png") no-repeat center;
    }

    .verification-line .el-input__inner {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      outline: none;
      color: rgba(255, 255, 255, 0.7);
      border-radius: 0;
    }

    .verification-line input:focus {
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    }

    .verification-line .el-input-group__append {
      background-color: transparent;
      border: none;
    }
  }

  /*移动端适应*/
  @media screen and (max-width: 320px) {
    html {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 321px) and (max-width: 360px) {
    html {
      font-size: 16px;
    }
  }

  @media screen and (min-width: 361px) and (max-width: 400px) {
    html {
      font-size: 18px;
    }
  }

  @media screen and (min-width: 401px) and (max-width: 440px) {
    html {
      font-size: 20px;
    }
  }

  @media screen and (min-width: 441px) and (max-width: 480px) {
    html {
      font-size: 22px;
    }
  }

  @media screen and (min-width: 481px) and (max-width: 640px) {
    html {
      font-size: 28px;
    }
  }

  @media screen and (min-width: 641px) and (max-width: 768px) {
    html {
      font-size: 25px;
    }
  }

  /*移动端登陆样式结束*/
</style>

<template>
  <div id="body">
    <div class="login-origion"
         v-loading="loginloading"
         element-loading-text="正在登录中">
      <div class="logBox">
        <form id="loginForm" method="post" autocomplete="off">
          <div class="login-box">
            <div class="platformBox">第三方API接口管理平台</div>
            <div class="username-line">
              <span></span>
              <el-input type="text" placeholder="请输入用户名" name="userID" id="userID" v-model="user.userID"
                        autofocus
                        @keydown.enter.native="NextInput('userID')">
                <template slot="prepend"><i></i></template>
              </el-input>
            </div>
            <div class="password-line">
              <el-input type="password" placeholder="请输入密码" name="password" id="password"
                        v-model="user.passWord"
                        @keydown.enter.native="NextInput('password')">
                <template slot="prepend"><i></i></template>
              </el-input>
            </div>
            <el-alert v-show="isError"
                      v-bind:title="errrorMsg"
                      type="error"
                      :closable="false"
                      show-icon>
            </el-alert>
            <div class="verification-line">
              <el-input v-show="isInputVerifyCode()"
                        type="text"
                        placeholder="验证码"
                        name="verificationcode"
                        id="verificationcode"
                        v-model="user.verifyCode"
                        @keydown.enter.native="NextInput('verificationcode')">
                <template slot="append">
                  <div id="v_container" style="width: 140px;height: 30px;"></div>
                </template>
              </el-input>
            </div>
            <div class="remenber-line" style="text-align: right;">
              <input type="checkbox" v-model="remenberPassword" id="remenber-checkbox" style="vertical-align: middle"
                     v-on:click="doRemenberPassword($event)">
              <label for="remenber-checkbox" style="font-size: 14px;vertical-align: middle">记住帐号</label>
            </div>
            <!--
            <div class="remember-password">
                <div class="check-box">
                    <input type="checkbox" name="remember_password"/>记住密码
                </div>
            </div>
            -->
            <button type="button" class="login-btn" id="login-btn" @click="login()">登 录</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import store from './vuex/store'
  import util from './util'
  import {systemInfo} from './vuex/getters'
  import {sessionUserLogin, systemInfo_Init, TestDemo} from './vuex/actions'
  export default {
    store,
    vuex: {
      getters: {
        systemInfo,
      },
      actions: {
        sessionUserLogin,
        systemInfo_Init,
      }
    },
    data(){
      return {
        remenberPassword: false,
        errrorMsg: "",
        isError: false,
        passwordErrorCount: 0,
        verifyCode: [],
        user: {
          userID: "",
          passWord: "",
          modulus: '',
          exponent: '',
          version: '',
          verifyCode: '',
        },
        loginSystemInfo: {
          systemRoleID: '001',
          systemName: '运营平台',
        },
        loginloading: false,
      }
    },
    watch: {},
    computed: {
      systemRoleID(){
        if (window.localStorage.getItem(util.systemInfo()))
          return this.loginSystemInfo.systemRoleID
        else
          return this.systemInfo.systemRoleID;
      },
      systemName(){
        if (window.localStorage.getItem(util.systemInfo()))
          return this.loginSystemInfo.systemName
        else
          return this.systemInfo.systemName;
      },
    },
    created(){
      this.systemInfo_Init(this.loginSystemInfo);
    },
    mounted(){
      this.loadAccountInfo();
      if (window.localStorage.getItem(util.systemInfo()) != null) {
        this.loginSystemInfo.systemRoleID = this.systemInfo.systemRoleID;
        this.loginSystemInfo.systemName = this.systemInfo.systemName;
      }
      else {
        this.loginSystemInfo.systemRoleID = '001';
        this.loginSystemInfo.systemName = '运营平台';
      }
      ;
      this.SystemRoleChangeEvents();
      $(document)[0].title = "领锋智能第三方API平台"
      this.createVerifyCode();
      this.verifyCode.refresh();
      $('#userID input').focus();
      var self = this;
      $.ajax({
        url: util.getUrl() + "/user/publicKey",
        dataType: "json",
        type: "post",
        success(d){
          if (d.isValid) {
            self.user.modulus = d.modulus;
            self.user.exponent = d.exponent;
            self.user.version = d.version;
          } else {
            self.errrorMsg = '获取版本信息失败!';
            self.isError = true;
            self.$message.error(self.errrorMsg);
          }
        },
        error(e){
          self.errrorMsg = '初始化系统异常!';
          self.isError = true;
          self.$message.error(self.errrorMsg);
        }
      })
    },
    methods: {
      loadAccountInfo: function () {

        let mySelf = this;
        let accountInfo = util.getCookie(util.accountInfo());
        if (Boolean(accountInfo) == false) {
          console.log('cookie中没有检测到账号信息！');
          return false;
        }
        else {
          mySelf.user.userID = accountInfo;
          mySelf.remenberPassword = true;
        }
      },
      createVerifyCode(){
        this.verifyCode = new GVerify("v_container");
        this.verifyCode.options.type = 'number';
      },
      check() {
        var _self = this;
        if ($.trim(_self.user.userID).length < 1) {
          this.errrorMsg = '请填写用户名';
          this.isError = true;
          this.$message.error(this.errrorMsg);
          return false;
        }
        ;
        if (_self.isInputVerifyCode()) {
          if ($.trim(_self.user.verifyCode).length < 1) {
            $('#verificationcode input').focus();
            _self.errrorMsg = '请输入验证码！';
            _self.isError = true;
            _self.$message.error(this.errrorMsg);
            return false;
          }
          ;
          //console.log(_self.verifyCode.options.code);
          if (!_self.verifyCode.validate(_self.user.verifyCode)) {
            $('#verificationcode input').focus();
            _self.verifyCode.refresh();
            _self.errrorMsg = '请输入正确的验证码！';
            _self.isError = true;
            _self.$message.error(this.errrorMsg);
            return false;
          }
        }
        ;
        this.errrorMsg = '';
        this.isError = false;
        return true;
      },
      SystemRoleChangeEvents(tab){
        let self = this;
        if (self.loginSystemInfo.systemRoleID == '001') {
          self.loginSystemInfo.systemName = '运营平台';
        } else if (this.loginSystemInfo.systemRoleID == '002') {
          self.loginSystemInfo.systemName = '经销商后台';
        } else if (this.loginSystemInfo.systemRoleID == '003') {
          self.loginSystemInfo.systemName = '供应商后台';
        }
        ;
        //console.log("loginVue 页面点击后的 ..."+JSON.stringify(this.loginSystemInfo))
        window.localStorage.setItem(util.systemInfo(), JSON.stringify(self.loginSystemInfo));
        self.systemInfo_Init(self.loginSystemInfo);
        $(document)[0].title = "领锋智能-" + self.loginSystemInfo.systemName;

        // console.log("store.js中的。。。。。"+JSON.stringify(this.systemInfo))
      },
      NextInput(val){
        //console.log(event.keyCode);
        //console.log(val);
        if (!this.check()) {
          return;
        }
        ;
        if (val == 'verificationcode') {
          this.login();
          return;
        }
        ;
        if (val == 'password' && !this.isInputVerifyCode())// && event.keyCode==13)
        {
          this.login();
          return;
        }
        ;
        if (val == 'password' && this.isInputVerifyCode()) {
          $('#verificationcode input').focus();
          return;
        }
        ;
        var el = document.getElementById("loginForm");
        for (var i = 0; i < el.length; i++) {
          //console.log(el[i]);
          if (el[i].name != val && (el[i].type == 'text' || el[i].type == 'password'))  // && event.keyCode==13
          {
            el[i].focus();
            break;
          }
        }
      },
      login() {
        if (!this.check()) {
          return;
        }
        ;
        var rsa = new RSAKey();
        rsa.setPublic(this.user.modulus, this.user.exponent);
        var accountInfo = this.user.userID;
        var userId = rsa.encrypt(this.user.userID);
        var password = rsa.encrypt(this.user.passWord);
        var version = rsa.encrypt(this.user.version);
        var self = this;
        var rememberStatus = self.remenberPassword;
        self.loginloading = true;
        $.ajax({
          url: util.getUrl() + "/user/logon",
          dataType: "json",
          async: false,
          data: {
            userID: userId,
            password: password,
            version: version,
            LangID: 936
          },
          type: "post",
          error(){
            self.errrorMsg = "系统异常";
            self.isError = true;
            self.$message.error(self.errrorMsg);
            self.loginloading = false;
          }
        }).then(function (d) {
          //console.log(self.user.userID);
          //{isValid: true, userName: "系统管理员", userId: "admin"}
          //console.log(JSON.stringify(d));
          //console.log(self.loginSystemInfo.systemRoleID)
          if (d.isValid) {
            $.ajax({
              url: util.getUrl() + "/StdQuery/StdQuery",
              dataType: "json",
              async: false,
              data: {
                queryName: "GetUserSystemRole",
                UserNO: self.user.userID,
                Operator: self.user.userID,
                SystemID: "01",
                SystemRoleID: '001',
                LangID: 936
              },
              type: "post",
              headers: {"token": d.token},
              success(data){
                if (data.isValid) {
                  //console.log(JSON.stringify(data.data.dataList));
                  if (data.data.dataList && data.data.dataList.length > 0) {
                    if (rememberStatus) {
                      console.log("勾选了记住密码，现在开始写入cookie");
                      util.setCookie(util.accountInfo(), accountInfo, 1440 * 3);
                    }
                    else {
                      console.log("没有勾选记住密码，现在开始删除账号cookie");
                      util.delCookie(util.accountInfo());
                    }
                    self.errrorMsg = "";
                    self.isError = false;
                    //登录成功
                    self.sessionUserLogin(d);
                    self.jumpUrl();
                  }
                  else {
                    self.errrorMsg = '您输入的用户没有访问当前系统的权限！';
                    self.isError = true;
                    self.$message.error(self.errrorMsg);
                  }
                  //self.verifyCode = null;
                }
                else {
                  self.errrorMsg = data.errors.map(e => {
                    return e.errorMsg
                  }).join(";");
                  self.isError = true;
                  self.$message.error(self.errrorMsg);
                }
                self.loginloading = false;
              },
              error(e){
                self.errrorMsg = e.message;
                self.isError = true;
                self.$message.error(e.message);
                self.loginloading = false;
              }
            })

          } else {
            self.passwordErrorCount++;
            self.errrorMsg = d.errors;
            self.isError = true;
            self.$message.error(self.errrorMsg);
            self.loginloading = false;
          }
        });
      },
      isInputVerifyCode(){
        return this.passwordErrorCount >= 3;
      },
      doRemenberPassword: function (event) {
        let mySelf = this;
        let remenberStatus = mySelf.remenberPassword;
        mySelf.remenberPassword = !remenberStatus;
      },
      jumpUrl(){
        //console.log(this.$route.query.jumpUrl);
        if (this.$route.query.jumpUrl != undefined) {
          //window.router.replace({path:jumpUrl});
          router.push({path: this.$route.query.jumpUrl});
        } else {
          //window.router.replace({name:"home"});
          router.push({name: "a00299303"});
        }
      },
    },
    route: {
      activate(transition){
        if (window.sessionStorage.getItem("jumpUrl") != null) {
          this.errrorMsg = '用户信息已失效，请重新登录!';
          this.isError = true;
          this.$message.error(this.errrorMsg);
          //layer.msg("用户信息已失效，请重新登录")
        }
        transition.next();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Login.vue?44a95b10